import React, { type ReactElement } from 'react'
import splashScreen from 'common/assets/splashScreen-1280px.svg'
import splashScreenLogo from 'common/assets/splashScreenLogo.svg'
import CDTsplash from 'common/assets/CDTsplash.svg'

import styles from './SplashScreen.module.scss'

const SplashScreen: React.FC = (): ReactElement => {
  return (
    <div className={styles.container} style={{ backgroundImage: `url(${splashScreen})` }}>
      <img src={splashScreenLogo} alt="Splash screen logo" className={styles.logo} />
      <div className={styles.textContainer}>
        <img src={CDTsplash} alt="Splash screen logo text" className={styles.logoText} />
        <p className={styles.text}>Centar za digitalnu transformaciju</p>
      </div>
    </div>
  )
}

export default SplashScreen
